/**
 * Uploads one font file the way ImageUpload does (same bucket folder, same
 * media row), but without FilePond: FilePond keeps one file type per
 * component, which breaks when several fonts arrive at once.
 */
import slugify from '@sindresorhus/slugify';
import { uploadFileToAws } from '@/plugins/aws';
import InsertImage from '@/graphQlQueries/mutations/insertImages';
import GetGroupObjectByGroupId from '@/graphQlQueries/queries/getGroupObjectByGroupId';
import UpdateGroupSettings from '@/graphQlQueries/mutations/updateGroupSettings';
import { dateiTyp, familieErsetzen } from '@/components/settings/eigeneSchriften';

export async function schriftHochladen({
  apollo, file, groupId, groupSlug, author,
}) {
  const type = dateiTyp(file.name);
  if (!type) throw new Error(`not a font: ${file.name}`);
  const basis = file.name.replace(/\.[^.]+$/, '');
  const ext = file.name.split('.').pop().toLowerCase();
  const filename = `${slugify(`${basis}-${Date.now()}`)}.${ext}`;
  const month = (`0${new Date().getMonth() + 1}`).slice(-2);
  const url = await uploadFileToAws(`${groupSlug}/${new Date().getFullYear()}/${month}`, { filename, file, type });
  if (!url) throw new Error(`upload failed: ${file.name}`);
  await apollo.mutate({
    mutation: InsertImage,
    variables: {
      object: {
        group_id: groupId, name: filename, url, metadata: { fileSize: file.size }, author,
      },
    },
  });
  return { name: file.name, url, filetype: type };
}

/**
 * Saves one family into the account, read fresh from the database so a CI
 * page with old group data never overwrites other settings.
 */
export async function familieSpeichern({
  apollo, groupId, alterName, name, schnitte,
}) {
  const { data } = await apollo.query({
    query: GetGroupObjectByGroupId,
    variables: { groupId },
    fetchPolicy: 'network-only',
  });
  const settings = { ...((data.groups[0] && data.groups[0].settings) || {}) };
  settings.customFonts = familieErsetzen(settings.customFonts, alterName, name, schnitte);
  await apollo.mutate({ mutation: UpdateGroupSettings, variables: { group_id: groupId, settings } });
  return settings;
}
